
import { Component, Vue } from 'vue-property-decorator'
import { IMockTopApi, MOCK_TOP_API } from '@/constants/monitor-mock'

@Component({ name: 'DashboardTopApiTable' })
export default class DashboardTopApiTable extends Vue {
    private rows: IMockTopApi[] = MOCK_TOP_API

    /** 行点击：模块一仅路由到接口分析占位页，模块二接入下钻 */
    private onClick(row: IMockTopApi) {
        this.$router.push('/monitor/api').catch(() => { /* 路由已注册 */ })
    }

    /** 千分位格式化 */
    private formatNumber(n: number): string {
        return n.toLocaleString()
    }
}
